import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const BillPayComponent = React.lazy(() => import("../Components/RootComponents/BillPayComponent"));
const BillPayPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <BillPayComponent />
      </Suspense>
    </Fragment>
  );
};

export default BillPayPage;
